import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import UserDto from "../../dto/UserDto";

const initialState: {
  user?: UserDto;
} = {};

export const userReducer = createSlice({
  name: "user",
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadUser(_state, _action: PayloadAction<number>) {},
    setLoadedUser(state, action) {
      state.user = action.payload;
    },
  },
});

export const { loadUser, setLoadedUser } = userReducer.actions;
